export default function buildGetUserBanEvent({
    apiEndpoint,
    apiTools
}) {
    return async function getUserBanEvent(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/ban-event` 
        })
       
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
            'Authorization': 'salaTokken'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}